import { DAY_START_HOUR, DATE_FORMAT } from 'lib/const'
import { WEEK, MONTH } from 'containers/Navigation/const'
import { SHIFT_START_MINUTES } from '../../lib/factoryTime'

export const selectNavigation = state => (
  {
    ...state.navigation,
    date: state.navigation.date ? state.navigation.date.clone() : state.navigation.date
  }
)
export const selectNavigationScope = state => state.navigation.scope
export const selectNavigationConstantScope = state => state.navigation.constantScope
export const selectNavigationDate = state => selectNavigation(state).date
export const selectNavigationShift = state => state.navigation.shift
export const selectNavigationLength = state => state.navigation.length
export const selectNavigationType = state => state.navigation.type
export const selectNavigationLocation = state => state.navigation.location
export const selectNavigationLocations = state => state.navigation.locations

const timeRange = (from, to) => ({
  from: from.clone().hour(DAY_START_HOUR),
  to: to.clone().hour(DAY_START_HOUR).add(1, 'day')
})

const timeRangeForShift = (date, shift) => {
  const shiftIdx = shift - 1
  const nextShiftIdx = shift >= SHIFT_START_MINUTES.length ? 0 : shift

  let nextShiftMinutes
  if (nextShiftIdx > 0) {
    nextShiftMinutes = SHIFT_START_MINUTES[nextShiftIdx]
  } else {
    nextShiftMinutes = 24 * 60 + SHIFT_START_MINUTES[0]
  }

  return {
    from: date.clone().minute(SHIFT_START_MINUTES[shiftIdx]),
    to: date.clone().minute(nextShiftMinutes)
  }
}

export const selectNavigationRange = (state, overrides = {}) => {
  const { date, scope, shift, length } = { ...state.navigation, ...overrides }
  let from, to

  if (scope === MONTH) {
    from = date.clone().startOf('month').subtract(length - 1, 'month')
    to = date.clone().startOf('month').add(1, 'month').subtract(1, 'day')
  } else if (scope === WEEK) {
    from = date.clone().startOf('isoWeek')
    to = date.clone().startOf('isoWeek').add(6, 'days')
  } else {
    from = date.clone().subtract(length - 1, 'day')
    to = date.clone()

    if (shift) {
      return timeRangeForShift(date, shift)
    }
  }

  return timeRange(from, to)
}

export const selectNavigationRangeDates = (state) => {
  const { from, to } = selectNavigationRange(state)
  return {
    from: from.format(DATE_FORMAT),
    to: to.clone().subtract(1, 'day').format(DATE_FORMAT)
  }
}
